export enum WorkspaceTab {
  All = 'all',
  Mine = 'created_by_me',
  Shared = 'shared',
}

export enum Data_Library_View {
  GRID = 'grid',
  LIST = 'list'
}

export enum RESOURCE_PROVIDERS_CODE {
  SHAREPOINT = 'E_RP_SP_ALP_EA',
  ONEDRIVE = 'E_RP_OD_ALP_EA',
  CONFLUENCE = 'E_RP_CF_ALP_EA',
  GOOGLEDRIVE = 'E_RP_GD_ALP_EA'
}

export enum CONFLUENCE_ROOT_FOLDER_TYPES {
  MY = 'my',
  SHARED = 'shared'
}

export enum INHERITANCE_STRATEGY {
  DEFAULT = 'default',
  FORCE = 'force',
  FILES_ONLY = 'files-only'
}

export enum ConfluenceNavLevel {
  Root = 'root',
  SpaceList = 'space-list',
  Content = 'content'
}

export enum GoogleDriveNavLevel {
  Root = 'root',
  Folders = 'folders'
}

export enum OneDriveNavLevel {
  Root = 'root',
  Folders = 'folders'
}

export enum SharePointNavLevel {
  Sites = 'sites',
  Drives = 'drives',
  DriveItems = 'driveItems',
  FolderItems = 'folderItems'
}
